<template>
  <div class="quick-creator-view">
    <div class="quick-form-list">
      <div class="quick-form-list-blank" v-if="formList.length === 0">
        <img :src="resource.blank" class="quick-form-list-blank-icon" />
        <div class="quick-form-list-blank-text">{{ $t('global-1.key174', { cm: '暂无可用单据' }) }}</div>
      </div>
      <div class="quick-form-item" v-for="form in formList" v-if="!form.disable">
        <div
          class="quick-form-item-title half-px-bottom-border"
          :class="{ 'has-histroy': form.historyList.length > 0, maintenance: showMaintenanceFlag(form) }"
          @click="selectCreateType(form)"
        >
          <img :src="form.icon" class="form-item-icon" />
          <div class="form-item-name">{{ form.name }}</div>

          <maintenance-tips v-if="showMaintenanceFlag(form)"></maintenance-tips>
          <img v-if="!showMaintenanceFlag(form)" :src="resource.add" class="form-item-create" />
        </div>
        <div
          class="quick-recent-document"
          :class="{ maintenance: showMaintenanceFlag(form) }"
          v-if="form.historyList.length > 0"
        >
          <div class="quick-recent-document-title">{{ $t('global-1.key175', { cm: '最近使用' }) }}</div>
          <div class="quick-recent-document-list">
            <div
              class="quick-recent-document-item"
              v-click-feedback
              v-for="history in form.historyList"
              @click="quicklyCreate(history, form)"
            >
              <div class="document-item-text">
                <div class="user-text">
                  <span v-if="history.isProxyFlag">{{ history.applicantName }}</span>
                  <span v-if="history.isProxyFlag" style="color: #8c96b4"> | </span>
                  <span v-if="history.applicantName" class="list-row extra-text">{{ history.formName }}</span>
                </div>
                <div class="job-text" v-if="history.userInfo">
                  {{ history.userInfo }}
                </div>
              </div>

              <img :src="resource.greyArrow" class="document-item-arrow" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="quick-menu-list"
      v-if="expenseCreateItem"
      :class="{ maintenance: showMaintenanceFlag(expenseCreateItem) }"
    >
      <div class="quick-menu-item" @click="expenseHandler('expense')">
        <div class="quick-menu-item-inner">
          <img :src="resource.maintenance" v-if="showMaintenanceFlag(expenseCreateItem)" class="maintenance-icon" />

          <img class="quick-menu-icon" :src="resource.expense" />
          <div class="quick-menu-text">{{ $t('global-1.key168', { cm: '记一笔' }) }}</div>
        </div>
      </div>
      <div class="quick-menu-item" v-if="ocrEnabled" @click="expenseHandler('ocr-event')">
        <div class="quick-menu-item-inner">
          <img :src="resource.maintenance" v-if="showMaintenanceFlag(expenseCreateItem)" class="maintenance-icon" />

          <img class="quick-menu-icon" :src="resource.ocr" />
          <div class="quick-menu-text">{{ $t('global-1.key176', { cm: '拍发票' }) }}</div>
        </div>
      </div>
      <div class="quick-menu-item" v-if="canScan" @click="expenseHandler('invoice-scan')">
        <div class="quick-menu-item-inner">
          <img :src="resource.maintenance" v-if="showMaintenanceFlag(expenseCreateItem)" class="maintenance-icon" />

          <img class="quick-menu-icon" :src="resource.scan" />
          <div class="quick-menu-text">{{ $t('global-1.key177', { cm: '扫发票' }) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// component
import MaintenanceTips from 'components/business/refactor-main/maintenance-tips/index';

//image
import add from 'assets/images/common/add-btn@3x.png';
import blank from 'assets/images/refactor-main/quick-create/blank.png';
import expenseClaim from 'assets/images/refactor-main/quick-create/expense-claim.png';
import loanBill from 'assets/images/refactor-main/quick-create/loan-bill.png';
import request from 'assets/images/refactor-main/quick-create/request.png';
import expense from 'assets/images/refactor-main/quick-create/expense.png';
import ocr from 'assets/images/refactor-main/quick-create/ocr.png';
import scan from 'assets/images/refactor-main/quick-create/scan.png';
import greyArrow from 'assets/images/application/travel/arrow-right@3x.png';
import maintenance from 'assets/images/refactor-main/maintenance.png';
import corpPayment from 'assets/images/refactor-main/quick-create/corp-payment@3x.png';
import corpRequest from 'assets/images/refactor-main/quick-create/corp-request@3x.png';
import apRequest from 'assets/images/refactor-main/quick-create/ap-request.png';

//api
import { checkInvoiceEnable } from 'api/expense';
import { getIsWhitelist, isStopService } from 'service/main/index.js';
import { mapGetters } from 'vuex';

export default {
  name: 'quickly-creator',
  mixins: [],
  props: {
    formType: {
      type: String,
    },
    value: {
      type: Boolean,
      default: false,
    },
    createEnters: {
      type: Array,
      default() {
        return [];
      },
    },
    historyList: {
      type: Array,
      default() {
        return [];
      },
    },
    isMaintenance: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resource: {
        blank,
        expenseClaim,
        request,
        expense,
        loanBill,
        ocr,
        scan,
        add,
        greyArrow,
        maintenance,
        corpPayment,
        corpRequest,
      },
      expenseCreateItem: null,
      ocrEnabled: false,
      appCodeIconMap: {
        LOAN_BILL: loanBill,
        APPLICATION_FORM: request,
        AP_REQUEST: apRequest,
        EXPENSE_CLAIM: expenseClaim,
        BUSSINESS_PAYMENT: corpPayment,
        FOR_SEARCH_SHOP_APPLICATION: corpRequest,
      },
    };
  },
  computed: {
    ...mapGetters(['getQuickMenu']),

    formList() {
      let formList = [];
      let historyListMap = {};
      if (this.historyList) {
        this.historyList.forEach((history) => {
          if (historyListMap[history.appCode]) {
            historyListMap[history.appCode].push(history);
          } else {
            historyListMap[history.appCode] = [history];
          }
        });
      }

      if (this.createEnters) {
        this.createEnters.forEach((createEnter) => {
          if (!createEnter.disable) {
            if (createEnter.appCode !== 'EXPENSE_LIST') {
              createEnter.historyList = historyListMap[createEnter.appCode] || [];
              createEnter.icon = this.appCodeIconMap[createEnter.appCode] || createEnter.icon;
              formList.push(createEnter);
            } else {
              this.expenseCreateItem = createEnter;
            }
          }
        });
      }

      return formList;
    },
    canScan() {
      return this.COMMON.getOption('receiptSourceOpt.scanningInvoice');
    },
  },
  watch: {},
  methods: {
    expenseHandler(type) {
      if (this.expenseCreateItem) {
        if (this.showMaintenanceFlag(this.expenseCreateItem)) {
          this.$plugins.maintenance.show();
          return;
        }
        this.expenseCreateItem.target = type;
        this.$emit('selectCreateType', this.expenseCreateItem);
      }
    },
    quicklyCreate(history, form) {
      if (this.showMaintenanceFlag(form)) {
        this.$plugins.maintenance.show();
        return;
      }

      this.$emit('quicklyCreate', history);
    },
    showMaintenanceFlag(appItem) {
      let isWhitelist = false;
      let stopAnnouncement = this.$store.getters.getStopAnnouncement;
      isWhitelist = getIsWhitelist(appItem.appCode, this.$store.getters.getAllApplicationList);
      return isStopService(stopAnnouncement) && !isWhitelist;
    },
    selectCreateType(form) {
      if (this.showMaintenanceFlag(form)) {
        this.$plugins.maintenance.show();
        return;
      }
      this.$emit('selectCreateType', form);
    },
    getIcon() {},
  },
  created() {},
  mounted() {
    let userOID = this.$store.getters.getMyInfo && this.$store.getters.getMyInfo.userOID;
    checkInvoiceEnable(userOID).then((res) => {
      this.ocrEnabled = res.data.showOCRFlag;
    });
  },
  components: {
    MaintenanceTips,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';
.quick-creator-view {
  height: calc(100% - 0.9rem);
  display: flex;
  flex-direction: column;
  padding-top: px(20);
  .quick-form-list {
    flex: 1;
    overflow-y: auto;
    padding-bottom: px(20);

    .quick-form-list-blank {
      .quick-form-list-blank-icon {
        display: block;
        width: px(128);
        height: px(128);
        margin-left: auto;
        margin-right: auto;
        margin-top: 30%;
      }
      .quick-form-list-blank-text {
        font-family: PingFangSC-Regular;
        font-size: px(30);
        color: #505564;
        text-align: center;
        line-height: px(32);
        margin-top: px(34);
      }
    }
    .quick-form-item {
      background: #f8f8f8;
      border-radius: px(8);
      margin: px(20) px(30) 0 px(30);
      padding: 0 px(40);
      .quick-form-item-title {
        padding: px(22) 0;
        display: flex;
        align-items: center;
        &.maintenance {
          .form-item-icon,
          .form-item-name {
            opacity: 0.6;
          }
        }
        &.has-histroy {
          .form-item-icon {
            width: px(56);
            height: px(56);
          }
        }
        .form-item-icon {
          width: px(56);
          height: px(56);
        }
        .form-item-name {
          padding-left: px(20);
          flex: 1;
          font-family: PingFangSC-Regular;
          font-size: px(30);
          color: #505564;
          line-height: px(32);
        }
        .form-item-create {
          width: px(30);
          height: px(30);
        }
      }

      .quick-recent-document {
        padding: px(20) 0 px(30) 0;
        font-family: PingFangSC-Regular;
        font-size: px(24);
        color: #8c96b4;
        letter-spacing: 0;
        line-height: 1;

        &.maintenance {
          opacity: 0.4;
        }
      }

      .quick-recent-document-list {
        margin-top: px(15);
        .quick-recent-document-item {
          font-family: PingFangSC-Medium;
          font-size: px(30);
          color: #0a0f1e;
          letter-spacing: 0;
          line-height: px(32);
          padding: px(15) 0;
          display: flex;
          align-items: center;
          .document-item-text {
            flex: 1;
            .user-text {
              font-family: PingFangSC-Medium;
              font-size: px(32);
              color: #0a0f1e;
              letter-spacing: 0;
              line-height: px(48);
            }
            .job-text {
              font-family: PingFangSC-Regular;
              font-size: px(24);
              color: #8c96b4;
              line-height: px(36);
            }
            .list-row {
              width: 100%;
              flex-shrink: 0;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-family: PingFangSC-Medium;
              font-size: px(32);
              color: #0a0f1e;
            }
          }
          .document-item-arrow {
            width: px(24);
            height: px(24);
          }
        }
      }
    }
  }

  .quick-menu-list {
    display: flex;
    align-items: center;
    padding: px(20) 0;

    &.maintenance {
      .quick-menu-icon,
      .quick-menu-text {
        opacity: 0.6;
      }
    }

    .quick-menu-item {
      flex: 1;
      display: flex;

      .quick-menu-item-inner {
        display: flex;
        align-items: center;
        margin-left: auto;
        margin-right: auto;
        position: relative;

        .maintenance-icon {
          top: -0.1rem;
          left: 0.1rem;
          position: absolute;
          width: px(32);
          height: px(32);
        }

        .quick-menu-icon {
          width: px(48);
          height: px(48);
        }
        .quick-menu-text {
          padding-left: px(16);
          font-family: PingFangSC-Regular;
          font-size: px(28);
          color: #505564;
          letter-spacing: 0;
          line-height: px(28);
        }
      }
    }
  }
}
</style>
